var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70597 7.20646C6.3155 7.59693 5.68137 7.59693 5.2909 7.20646L0.292854 2.20841C-0.0976182 1.81794 -0.0976181 1.18381 0.292854 0.793342C0.683327 0.40287 1.31746 0.40287 1.70793 0.793342L6 5.08542L10.2921 0.796466C10.6825 0.405994 11.3167 0.405994 11.7071 0.796466C12.0976 1.18694 12.0976 1.82107 11.7071 2.21154L6.7091 7.20959L6.70597 7.20646Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.53edd82dad645d1dabfc4bb1fc3ac12b.svg";
export { ForwardRef as ReactComponent };